<template>
  <div class="site-content">
    <app-breadcrumb v-bind:items="breadcrumbList"></app-breadcrumb>

    <div class="container">
      <div class="row">
        <div class="col-4">
          <slot name="sidebar"></slot>
        </div>
        <main class="col-16">
          <slot name="content"></slot>
        </main>
      </div>
    </div>

  </div>
</template>

<script>
  import AppBreadcrumb from '../components/AppBreadcrumb';
  import AppBreadcrumbItem from '../components/AppBreadcrumbItem';

  export default {
    components: {
      AppBreadcrumb,
      AppBreadcrumbItem,
    },
    data() {
      return {
        breadcrumbList: [],
      };
    },
    mounted() {
      this.breadcrumbList = this.$parent.$parent.breadcrumbList;
    },
  };
</script>



// WEBPACK FOOTER //
// MainLayout.vue?7c02f042